import axios from "axios";

export default {
    findByPatientId(patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/historicOld/patient/" +
                patientId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
